export default __webpack_public_path__ + "static/media/1141.2a50b37a.png";